var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('zoom-on-hover',{staticClass:"img-fluid",attrs:{"img-normal":_vm.photo,"scale":2}})}
var staticRenderFns = []

export { render, staticRenderFns }